module.exports = __webpack_public_path__ + "static/media/username.9c6c956f.svg";